//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Berekent de annuitaire aflossing per termijn.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    annuitaire_aflossing(body: AnnuitaireAflossingInput | null | undefined): Promise<AnnuitaireAflossingOutput> {
        let url_ = this.baseUrl + "/AnnuitaireAflossing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnnuitaire_aflossing(_response);
        });
    }

    protected processAnnuitaire_aflossing(response: Response): Promise<AnnuitaireAflossingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuitaireAflossingOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuitaireAflossingOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuitaireAflossingOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnnuitaireAflossingOutput>(null as any);
    }

    /**
     * Berekent de annuitaire factor op basis van het rentepercentage en de maand.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    annuitaire_factor(body: AnnuitaireFactorInput | null | undefined): Promise<AnnuitaireFactorOutput> {
        let url_ = this.baseUrl + "/AnnuitaireFactor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnnuitaire_factor(_response);
        });
    }

    protected processAnnuitaire_factor(response: Response): Promise<AnnuitaireFactorOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuitaireFactorOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuitaireFactorOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuitaireFactorOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnnuitaireFactorOutput>(null as any);
    }

    /**
     * Berekent het benodigd inkomen voor een hypotheek
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    benodigd_inkomen(body: BenodigdInkomenInput | null | undefined): Promise<BenodigdInkomenOutput> {
        let url_ = this.baseUrl + "/BenodigdInkomen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBenodigd_inkomen(_response);
        });
    }

    protected processBenodigd_inkomen(response: Response): Promise<BenodigdInkomenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BenodigdInkomenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BenodigdInkomenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BenodigdInkomenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BenodigdInkomenOutput>(null as any);
    }

    /**
     * Berekent de boeterente volgens de contante waarde methode.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    contante_waarde(body: BoeterenteContanteWaardeInput | null | undefined): Promise<BoeterenteContanteWaardeOutput> {
        let url_ = this.baseUrl + "/Boeterente/ContanteWaarde";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContante_waarde(_response);
        });
    }

    protected processContante_waarde(response: Response): Promise<BoeterenteContanteWaardeOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoeterenteContanteWaardeOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoeterenteContanteWaardeOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoeterenteContanteWaardeOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoeterenteContanteWaardeOutput>(null as any);
    }

    /**
     * Berekent de eigenwoningschuld.
     * @param body (optional) 
     * @return OK
     */
    eigenwoningschuld(body: EwsInput | null | undefined): Promise<EwsOutput> {
        let url_ = this.baseUrl + "/Ews/Eigenwoningschuld";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEigenwoningschuld(_response);
        });
    }

    protected processEigenwoningschuld(response: Response): Promise<EwsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EwsOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EwsOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EwsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EwsOutput>(null as any);
    }

    /**
     * Berekent de financieringsbehoefte op basis van o.a. koopsom en inbreng eigen middelen.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    financieringsbehoefte(body: FinancieringsbehoefteInput | null | undefined): Promise<FinancieringsbehoefteOutput> {
        let url_ = this.baseUrl + "/Financieringsbehoefte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinancieringsbehoefte(_response);
        });
    }

    protected processFinancieringsbehoefte(response: Response): Promise<FinancieringsbehoefteOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoefteOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoefteOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoefteOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancieringsbehoefteOutput>(null as any);
    }

    /**
     * Berekent de financieringsbehoefte op basis van o.a. koopsom en inbreng eigen middelen.
     * @param body (optional) De uitgebreide input voor de berekening
     * @return OK
     */
    uitgebreide_financieringsbehoefte(body: FinancieringsbehoefteExtInput | null | undefined): Promise<FinancieringsbehoefteOutput> {
        let url_ = this.baseUrl + "/Financieringsbehoefte/Ext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUitgebreide_financieringsbehoefte(_response);
        });
    }

    protected processUitgebreide_financieringsbehoefte(response: Response): Promise<FinancieringsbehoefteOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoefteOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoefteOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoefteOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancieringsbehoefteOutput>(null as any);
    }

    /**
     * Berekent de maximale hypotheek.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    maximale_hypotheek(body: MaximaleHypotheekInput | null | undefined): Promise<MaximaleHypotheekOutput> {
        let url_ = this.baseUrl + "/Hypotheek/MaximaleHypotheek";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaximale_hypotheek(_response);
        });
    }

    protected processMaximale_hypotheek(response: Response): Promise<MaximaleHypotheekOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaximaleHypotheekOutput>(null as any);
    }

    /**
     * Bepaalt de AOW datum op basis van de geboortedatum.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    aow_datum(body: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Hypotheek/AowDatum";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAow_datum(_response);
        });
    }

    protected processAow_datum(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Berekent de lineaire aflossing per termijn.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    lineare_aflossing(body: LineaireAflossingInput | null | undefined): Promise<LineaireAflossingOutput> {
        let url_ = this.baseUrl + "/LineaireAflossing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLineare_aflossing(_response);
        });
    }

    protected processLineare_aflossing(response: Response): Promise<LineaireAflossingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LineaireAflossingOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LineaireAflossingOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LineaireAflossingOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineaireAflossingOutput>(null as any);
    }

    /**
     * Berekent het overbruggingskrediet.
     * @param body (optional) 
     * @return OK
     */
    overbruggingskrediet(body: OverbruggingskredietInput | null | undefined): Promise<OverbruggingskredietOutput> {
        let url_ = this.baseUrl + "/Overbruggingskrediet/Overbruggingskrediet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverbruggingskrediet(_response);
        });
    }

    protected processOverbruggingskrediet(response: Response): Promise<OverbruggingskredietOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbruggingskredietOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbruggingskredietOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbruggingskredietOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverbruggingskredietOutput>(null as any);
    }

    /**
     * Berekent renteverlies tijdens bouw.
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    renteverlies_tijdens_bouw(body: RenteverliesTijdensBouwInput | null | undefined): Promise<RenteverliesTijdensBouwOutput> {
        let url_ = this.baseUrl + "/RenteverliesTijdensBouw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenteverlies_tijdens_bouw(_response);
        });
    }

    protected processRenteverlies_tijdens_bouw(response: Response): Promise<RenteverliesTijdensBouwOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteverliesTijdensBouwOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteverliesTijdensBouwOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteverliesTijdensBouwOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenteverliesTijdensBouwOutput>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * Geeft de foutcodes die in deze Web API kunnen ontstaan.
     * @return OK
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

/** Bevat informatie over de aanvrager */
export interface Aanvrager {
    /** Geboortedatum van de aanvrager */
    geboortedatum: string;
    /** Het inkomen van de aanvrager */
    inkomen: number;
}

/** Specificatie van de advies- en bemiddelingskosten. */
export interface AdviesBemidddelingskosten {
    /** Het bedrag aan advieskosten. */
    advieskosten: number | null;
    /** Het bedrag aan bemiddelingskosten geldlening. */
    bemiddelingskostenGeldlening: number | null;
    /** Het bedrag aan overige bemiddelingskosten. */
    overigeBemiddelingskosten: number | null;
    /** Het bedrag aan dossiervergoeding geldlening. */
    dossiervergoedingGeldlening: number | null;
    /** De afsluitkosten van een Svn Starterslening. */
    afsluitkostenSvnStarterslening: number | null;
    /** De afsluitkosten van een overbruggingskrediet. */
    afsluitkostenOverbruggingskrediet: number | null;
    /** De berekdstellingskosten. */
    bereidstellingskosten: number | null;
}

/** AflossingsVormType Geen = 0, Annuïteit = 1, Lineair = 2, Levensverzekering = 3, Spaar = 4, Aflosvrij = 5, Krediet = 9, Belegging = 10, Hybride = 11, UnitLinked = 12, Spaarrekening = 13, AnnuïteitUitgesteld = 20, AnnuïteitBlok = 21, KredietNoPay = 22 */
export enum AflossingsVormType {
    Geen = "Geen",
    Annuïteit = "Annuïteit",
    Lineair = "Lineair",
    Levensverzekering = "Levensverzekering",
    Spaar = "Spaar",
    Aflosvrij = "Aflosvrij",
    Krediet = "Krediet",
    Belegging = "Belegging",
    Hybride = "Hybride",
    UnitLinked = "UnitLinked",
    Spaarrekening = "Spaarrekening",
    AnnuïteitUitgesteld = "AnnuïteitUitgesteld",
    AnnuïteitBlok = "AnnuïteitBlok",
    KredietNoPay = "KredietNoPay",
}

/** AflosvormOptions Annuitair = 0, Lineair = 1, Aflossingsvrij = 2, Spaarrekening = 3 */
export enum AflosvormOptions {
    Annuitair = "Annuitair",
    Lineair = "Lineair",
    Aflossingsvrij = "Aflossingsvrij",
    Spaarrekening = "Spaarrekening",
}

/** De input voor de berekening van de annuitaire aflossing. */
export interface AnnuitaireAflossingInput {
    /** Looptijd in aantal termijnen (maanden of jaren). */
    aantalTermijnen: number | null;
    /** Rentepercentage per jaar. Gebruik 5 voor 5%, dus niet 0.05. */
    rente: number | null;
    /** De hoofdsom van de berekening, normaal gesproken het hypotheekbedrag. */
    hoofdsom: number | null;
    /** Indicatie dat het resultaat per maand teruggegeven moet worden. Indien ‘false’, dan worden de resultaten per jaar teruggegeven. */
    berekeningPerMaand: boolean;
}

/** Bevat de output van de annuitaire aflossing berekening. */
export interface AnnuitaireAflossingOutput {
    resultaat: AnnuitaireAflossingResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De annuitaire aflossing per termijn. */
export interface AnnuitaireAflossingPerTermijnOutput {
    /** De maandlast gedurende de hele looptijd. */
    maandlast: number;
    /** De termijn waarvoor de berekening geldt. */
    termijn: number;
    /** Het bedrag aan rente dat deze termijn betaald moet worden. */
    rentebedrag: number;
    /** Het bedrag aan aflossing dat deze termijn betaald moet worden. */
    aflossing: number;
    /** Het bedrag van de hoofdsom dat na deze maand overblijft. */
    restant: number;
}

/** Bevat het resultaat van de annuitaire aflossing berekening. */
export interface AnnuitaireAflossingResultaat {
    /** De gegevens van de annuitaire aflossing per termijn. */
    termijnen: AnnuitaireAflossingPerTermijnOutput[] | null;
}

/** De invoergegevens voor de berekening van de annuitaire factor. */
export interface AnnuitaireFactorInput {
    /** Het percentage waarmee gerekend wordt.

Als met 6% wordt gerekend, dan moet 6 doorgegeven worden en niet 0.06. */
    percentage: number | null;
    /** De maand waarvoor de annuitaire factor berekend moet worden. */
    maand: number | null;
}

/** Bevat de output van de annuitaire factor berekening. */
export interface AnnuitaireFactorOutput {
    resultaat: AnnuitaireFactorResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de annuitaire factor berekening. */
export interface AnnuitaireFactorResultaat {
    /** De berekende annuitaire factor. */
    waarde: number | null;
}

export interface BadRequestResult {
    statusCode: number;
}

/** Het input model voor de berekening van het benodigd inkomen */
export interface BenodigdInkomenInput {
    /** Collectie met aanvragers */
    aanvragers: Aanvrager[] | null;
    /** Volgnummer van de aanvrager van wie het inkomen vergehoogd wordt om het benodigd inkomen te berekenen */
    teVerhogenInkomen: number;
    /** Het bedrag aan hypotheek wat gewenst is */
    gewenstHypotheekbedrag: number;
    /** De toestrente. */
    toetsrente: number;
    aflossingsvorm: AflossingsVormType;
    /** De rentevastperiode van het leningdeel waarmee de berekening wordt uitgevoerd */
    rentevastAantalJaren: number;
    /** Hypotheekbedrag in box 3 */
    box3Bedrag: number;
    tarievenNorm: TarievenNorm | null;
}

/** Bevat de output van de benodigd inkomen berekening. */
export interface BenodigdInkomenOutput {
    resultaat: BenodigdInkomenResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de benodigd inkomen berekening. */
export interface BenodigdInkomenResultaat {
    /** Benodigd inkomen voor aanvrager 1 */
    benodigdInkomen1: number;
    /** Benodigd inkomen voor aanvrager 2 (indien aanwezig) */
    benodigdInkomen2: number | null;
    /** Volgnummer van de aanvrager van wie het inkomen verhoogd is om tot het benodigd inkomen te komen */
    gewijzigdInkomen: number;
}

/** Bevat de input voor de contante waardeberekening. */
export interface BoeterenteContanteWaardeInput {
    aflossingsVorm: AflossingsVormType;
    /** Oorspronkelijke hoofdsom */
    oorspronkelijkeHoofdsom: number;
    /** Restant hoofdsom */
    restantHoofdsom: number;
    /** Boetevrij percentage */
    boetevrijPercentage: number;
    /** Datum boeterente */
    datumBoeterente: string;
    /** Einddatum rentevastperiode */
    einddatumRentevastperiode: string;
    /** Opgebouwde waarde */
    opgebouwdeWaarde: number;
    /** Huidige contractrente */
    huidigRentePercentage: number;
    /** Nieuw rentepercentage */
    nieuwRentePercentage: number;
    /** Restant looptijd */
    restantLooptijdInMaanden: number;
}

/** Bevat de output van de contante waarde berekening. */
export interface BoeterenteContanteWaardeOutput {
    resultaat: BoeterenteContanteWaardeResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de contante waarde berekening. */
export interface BoeterenteContanteWaardeResultaat {
    /** Boeterente volgens de contante waardeberekening */
    contanteWaarde: number;
    /** Resterende rentevastperiode */
    restantRentevastperiodeInMaanden: number;
}

/** De invoer voor de eigenwoningschuld-berekening. */
export interface EwsInput {
    soortFinanciering: Financieringsoort;
    /** Koopsom van het pand. */
    koopsomBedrag: number | null;
    /** Bouwrente voor aankoop. */
    bouwrenteVoorAankoopBedrag: number | null;
    /** Bedrag aan verbouwingskosten. */
    verbouwingBedrag: number | null;
    /** Bedrag aan meerwerk. */
    meerwerkBedrag: number | null;
    /** Bedrag aan overdrachtsbelasting. */
    overdrachtsbelastingBedrag: number | null;
    /** Bedrag aan makelaarscourtage. */
    makelaarscourtageBedrag: number | null;
    /** Bedrag aan kosten transportakte. */
    transportakteBedrag: number | null;
    /** Bedrag aan afkoop erfpacht. */
    afkoopErfpachtBedrag: number | null;
    /** Bedrag aan uitkoop partner. */
    uitkoopPartnerBedrag: number | null;
    /** Eigenwoningreserve en vervreemdingssaldo. */
    ewrEnVvSaldoBedrag: number | null;
    /** Het totaal van de doorlopende leningdelen. */
    doorlopendeLeningdelenBedrag: number | null;
    /** Het aftrekbare deel van de advieskosten. */
    aftrekbareAdvieskosten: number | null;
    /** Kosten NHG. */
    nhgKosten: number | null;
    /** Kosten van de hypotheekakte. */
    hypotheekakteBedrag: number | null;
    /** Taxatiekosten. */
    taxatieBedrag: number | null;
    /** Bedrag arbeidskosten notaris */
    arbeidskostenNotarisBedrag: number | null;
    /** Afsluitkosten SVn Starterslening.
SVn: Stimuleringsfonds Volkshuisvesting */
    startersleningBedrag: number | null;
    /** Afsluitkosten overbruggingskrediet. */
    overbruggingskredietBedrag: number | null;
    /** Bereidstellingskosten. */
    bereidstellingskostenBedrag: number | null;
    /** Kosten omzetting leningde(e)l(en). */
    omzettingBedrag: number | null;
    /** Aftrekbare deel van de boeterente. */
    aftrekbareBoeterenteBedrag: number | null;
    /** Bedrag aan overige aftrekbare kosten. */
    overigeBedrag: number | null;
    /** Het percentage van de aftrekbare kosten dat meegenomen mag worden. */
    financieringskostenPercentage: number | null;
    /** Het aftrekbare bedrag van te beeindigen/af te lossen leningdelen. */
    teBeeindigenLeningdelenAftrekbaarBedrag: number | null;
    /** Het bedrag aan aflossing op eigenwoningschuld. */
    ewsAflossingBedrag: number | null;
    /** Bedrag aan gewenst hypotheek. */
    gewenstHypotheekBedrag: number | null;
}

/** De uitvoer van de eigenwoningschuld-berekening. */
export interface EwsOutput {
    /** Bedrag aan investering. */
    investeringBedrag: number | null;
    /** Totaal aan aftrekbare kosten. */
    financieringskostenAftrekbaarBedrag: number | null;
    /** Het bedrag aan financieringskosten. */
    financieringskostenBedrag: number | null;
    /** Maximaal te financieren bedrag in box 1. */
    maximaalTeFinancierenBox1Bedrag: number | null;
    /** Eigenwoningschuld bedrag */
    ewsBedrag: number | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het uitgebreide model voor de financieringsbehoefteberekening. */
export interface FinancieringsbehoefteExtInput {
    soortFinancieringsbehoefte: Financieringsoort;
    /** De koopsom van het aan te kopen pand (soort 1 en 2). */
    koopsom: number | null;
    /** Het bedrag aan roerende zaken (soort 1). */
    koopsomRoerendeZaken: number | null;
    overdrachtsbelasting: WaardeberekeningParameters | null;
    makelaarscourtage: WaardeberekeningParameters | null;
    leveringsakte: WaardeberekeningParameters | null;
    /** Geeft aan of er sprake is van een geheel perceel binnen de berekening van de kosten leveringsakte. */
    geheelPerceel: boolean | null;
    /** De verbouwingskosten (bestaande bouw) of kosten meerwerk (nieuwbouw). Als dit bedrag niet wordt gevuld, dan wordt naar de specificatie gekeken. */
    verbouwingskostenMeerwerk: number | null;
    specificatieVerbouwingskostenMeerwerk: VerbouwingVerbetering | null;
    /** Het bedrag aan afkoop erfpacht. */
    afkoopErfpacht: number | null;
    hypotheekakteKosten: WaardeberekeningParameters | null;
    taxatiekosten: WaardeberekeningParameters | null;
    nhgKosten: WaardeberekeningParameters | null;
    /** Het bedrag aan advies- en bemiddelingskosten. */
    advieskosten: number | null;
    /** Arbeidskosten van de Notaris */
    arbeidskostenNotarisBedrag: number | null;
    specificatieAdviesBemidddelingskosten: AdviesBemidddelingskosten | null;
    bankgarantie: WaardeberekeningParameters | null;
    /** Het bedrag aan bouwrente voor aankoop (soort 2). */
    bouwrenteVoorAankoop: number | null;
    /** Het bedrag aan bouwrente na aankoop (soort 2). */
    bouwrenteNaAankoop: number | null;
    /** Het bedrag dat betaald moet worden om een partner uit te kopen. */
    uitkoopPartner: number | null;
    /** Het bedrag aan renteverlies tijdens de bouw (soort 2). */
    renteverliesTijdensBouw: number | null;
    /** Het bedrag aan boeterente dat betaald moet worden. */
    boeterente: number | null;
    /** De totale restschuld (soort 1 en 2). */
    totaleRestschuld: number | null;
    /** De mee te financieren restschuld. */
    meeTeFinancierenRestschuld: number | null;
    /** Overige leningen die afgelost moeten worden binnen de gewenste hypotheek. */
    overigeAfTeLossen: number | null;
    kostenOmzetting: WaardeberekeningParameters | null;
    /** Het totaal aan overige kosten dat door de gewenste hypotheek afgedekt moet worden. */
    overigeKosten: number | null;
    /** Het totaal aan beschikbaar eigen geld. */
    beschikbaarEigenGeld: number | null;
    /** Inbreng opgebouwde waarde. */
    opgebouwdeWaardeBedrag: number | null;
    /** Bedrag Starterslening */
    starterslening: number | null;
    /** Het bedrag aan kortlopende kredieten waarmee de hypotheeksom verlaagd kan worden. */
    kortlopendeKredieten: number | null;
    /** De parameters voor de berekening van het overbruggingskrediet (soort 1 en 2). Bij SoortWaardeberekening = Default wordt het bedrag leeg gelaten. */
    overbruggingskrediet: number | null;
    /** Het totaalbedrag aan doorlopende hypotheken. */
    doorlopendeHypotheken: number | null;
    /** Het totaalbedrag aan eigen woning schuld. */
    eigenWoningSchuld: number | null;
    bevoorschotting: WaardeberekeningParameters | null;
    tarievenNorm: TarievenNorm | null;
    /** Het totaalbedrag aan af te lossen hypotheken. */
    afTeLossenHypotheken: number | null;
    /** Marktwaarde van het pand voor eventuele verbouwingen. */
    marktwaardeVoorVerbouwing: number | null;
    /** Marktwaarde van het pand na eventuele verbouwingen. */
    marktwaardeNaVerbouwing: number | null;
    /** Bedrag WOZ-waarde */
    wozWaarde: number | null;
    /** Het bedrag aan gewenst hypotheek. */
    gewensteHypotheek: number | null;
    /** De totale te hypotheek die op het te financieren pand rust */
    hypotheekOpPandBedrag: number | null;
    /** Het hypotheekbedrag dat als uitgangspunt dient voor de bepaling van het bevoorschottingspercentage (LTV-percentage) */
    ltvHypotheekBedrag: number | null;
    /** Tweede woning (box 3) */
    tweedeWoning: boolean;
    /** Vast bedrag voor 'Hypothecaire inschrijving' */
    inschrijvingInstellingVastBedrag: number | null;
    /** Percentage voor 'Hypothecaire inschrijving' */
    inschrijvingInstellingPercentage: number | null;
    hypothecaireInschrijving: WaardeberekeningParameters | null;
    /** Bestaand NHG bedrag. */
    bestaandNhgBedrag: number | null;
    /** Som doorlopende leningdelen zonder NHG. */
    doorlopendZonderNhgBedrag: number | null;
}

/** Input voor de berekening van de financieringsbehoefte. */
export interface FinancieringsbehoefteInput {
    /** Het te betalen bedrag voor het pand. */
    koopsom: number | null;
    /** Bedrag aan verbouwing (als bestaande bouw) of meerwerk (als nieuwbouw) */
    verbouwingskostenWaardevermeerderend: number | null;
    /** De kosten van de verbouwingen die niet onder VerbouwingskostenWaardevermeerderend vallen. */
    verbouwingskostenNietWaardevermeerderend: number | null;
    /** De opgegeven taxatiekosten, inclusief BTW. */
    taxatiekosten: number | null;
    /** Het bedrag dat uitgegeven is/wordt aan advieskosten. */
    advieskosten: number | null;
    /** Het bedrag dat uitgegeven is/wordt aan arbeidskosten van de notaris. */
    arbeidsNotariskosten: number | null;
    /** Het percentage aan overdrachtsbelasting waarmee gerekend wordt. */
    percentageOverdrachtsbelasting: number | null;
    /** De opgegeven makelaarskosten. */
    makelaarskosten: number | null;
    /** Het percentage aan makelaarskosten waarmee gerekend wordt. */
    percentageMakelaarskosten: number | null;
    /** Het bedrag aan notariskosten. */
    notariskosten: number | null;
    /** Bedrag aan kosten bankgarantie. */
    bankgarantieKosten: number | null;
    /** Indicatie dat het nieuwbouw betreft. */
    nieuwbouw: boolean;
    /** Het percentage aan bouwrente waarmee regekend moet worden. */
    percentageBouwrente: number | null;
    /** Indicatie of gebruik gemaakt wordt van NHG. */
    nhg: boolean;
    /** Het percentage aan kosten NHG waarmee gerekend wordt. */
    percentageKostenNhg: number | null;
    /** Het bedrag aan eigen geld dat in de koop wordt gestoken. */
    inbrengEigenGeld: number | null;
    /** Het bedrag aan overwaarde dat in de berekening gebruikt mag worden. */
    inbrengOverwaarde: number | null;
    /** Inbreng opgebouwde waarde. */
    opgebouwdeWaardeBedrag: number | null;
    /** Bestaand NHG bedrag. */
    bestaandNhgBedrag: number | null;
    /** Som doorlopende leningdelen zonder NHG. */
    doorlopendZonderNhgBedrag: number | null;
    tarievenNorm: TarievenNorm | null;
}

/** Bevat de output van de financieringsbehoefte berekening. */
export interface FinancieringsbehoefteOutput {
    resultaat: FinancieringsbehoefteResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de financieringsbehoefte berekening. */
export interface FinancieringsbehoefteResultaat {
    /** Het gebruikte bedrag aan taxatiekosten. */
    taxatiekosten: number | null;
    /** Het gebruikte bedrag aan overdrachtsbelasting. */
    overdrachtsbelasting: number | null;
    /** Het gebruikte bedrag aan makelaarskosten. */
    makelaarskosten: number | null;
    /** Het gebruikte bedrag aan bouwrente. */
    bouwrente: number | null;
    /** Het bedrag aan kosten NHG. */
    kostenNhg: number | null;
    /** Het uiteindelijk benodigde hypotheekbedrag. */
    hypotheekbedrag: number | null;
    /** Het benodigde eigen geld om de hypotheek mogelijk te maken. */
    benodigdEigenGeld: number | null;
    /** Maximale hypotheek op basis van de koopsom. */
    maximaleHypotheek: number | null;
    /** Geeft aan of NHG mogelijk is. */
    nhgMogelijk: boolean;
    /** Kosten van de leveringsakte */
    leveringsaktekosten: number | null;
    /** Kosten van de afkoop van de erfpacht */
    afkoopErfpacht: number | null;
    /** De kosten van het opmaken van de hypotheekakte */
    hypotheekaktekosten: number | null;
    /** De financieringsbehoefte, zijn alle kosten */
    financieringsbehoefte: number | null;
    /** Het bedrag van de hypothecaie inschrijving */
    bedragInschrijving: number | null;
    /** Het bevoorschottingspercentage */
    bevoorschottingspercentage: number | null;
    /** Het maximale bevoorschottingspercentage */
    maxBevoorschottingspercentage: number | null;
    nhgMogelijkResultaat: NhgMogelijkOutput | null;
}

/** Financieringsoort Geen = 0, AankoopBestaandeBouw = 1, AankoopNieuwbouw = 2, Oversluiten = 3, Heropname = 4, _2eHypotheek = 5, _3eHypotheek = 6, _4eHypotheek = 7, Omzetting = 8, _1eHypotheek = 9 */
export enum Financieringsoort {
    Geen = "Geen",
    AankoopBestaandeBouw = "AankoopBestaandeBouw",
    AankoopNieuwbouw = "AankoopNieuwbouw",
    Oversluiten = "Oversluiten",
    Heropname = "Heropname",
    _2eHypotheek = "_2eHypotheek",
    _3eHypotheek = "_3eHypotheek",
    _4eHypotheek = "_4eHypotheek",
    Omzetting = "Omzetting",
    _1eHypotheek = "_1eHypotheek",
}

/** KredietsoortOptions Doorlopend = 1, Aflopend = 2, Studielening = 3, RestschuldMetNhg = 4, RestschuldZonderNhg = 5 */
export enum KredietsoortOptions {
    Doorlopend = "Doorlopend",
    Aflopend = "Aflopend",
    Studielening = "Studielening",
    RestschuldMetNhg = "RestschuldMetNhg",
    RestschuldZonderNhg = "RestschuldZonderNhg",
}

/** De input voor de berekening van de lineaire aflossing */
export interface LineaireAflossingInput {
    /** Hypotheekbedrag */
    hypotheekBedrag: number;
    /** Rente per jaar. Gebruik 5m voor 5%, dus niet 0.05m */
    rente: number;
    /** Looptijd in maanden of jaren (afhankelijk van BerekeningPerMaand) */
    looptijd: number;
    /** Voer de berekening uit per maand. Dit corrigeert de rekenrente, maar het aantal termijn moet nog steeds correct opgegeven worden. */
    berekeningPerMaand: boolean;
}

/** Output van een lineaire output berekening */
export interface LineaireAflossingOutput {
    /** Lijst met resultaten van de lineaire aflossing berekening. */
    resultaten: LineaireAflossingResultaat[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Resultaat van een lineaire aflossing berekening */
export interface LineaireAflossingResultaat {
    /** Volgnummer van de termijn */
    termijn: number;
    /** Rente percentage over de specifieke termijn */
    rente: number;
    /** Verschuldigd bedrag aan rente */
    renteBedrag: number;
    /** Verschuldigd bedrag aan aflossing */
    aflossingBedrag: number;
    /** Rente + aflossing */
    totaalBedrag: number;
    /** Schuldbedrag na de aflossing */
    restant: number;
}

export interface MaxKoopsomOutput {
    success: boolean | null;
    readonly maxKoopsomBedrag: number | null;
}

export interface MaxKostenInEigendomOutput {
    success: boolean | null;
    readonly maxKostenInEigendomBedrag: number | null;
}

export interface MaxLeningOutput {
    success: boolean | null;
    readonly kostenInEigendomBedrag: number | null;
    readonly maxHypMarktwaardeBedrag: number | null;
}

/** De klantgegevens in het input-model. */
export interface MaximaleHypotheekAanvragerInput {
    /** Het jaarinkomen tot de pensioenleeftijd. */
    inkomen: number | null;
    /** Het jaarinkomen na de pensioenleeftijd. */
    pensioen: number | null;
    /** Toekomstig vrij vermogen */
    vermogen: number | null;
    /** Het bedrag, op jaarbasis, aan te betalen alimentatie. */
    teBetalenAlimentatie: number | null;
    /** Het bedrag, op jaarbasis, aan te ontvangen alimentatie. */
    teOntvangenAlimentatie: number | null;
    /** De geboortedatum van de persoon.
Als de geboortedatum meegegeven wordt, dan worden leeftijd en de pensioendatum bepaald a.d.h.v. die datum.
Als de geboortedatum achterwege gelaten wordt, dan worden Leeftijd en Pensioenleeftijd gebruikt. */
    geboortedatum: string | null;
    /** De AOW-datum, vastgesteld a.d.h.v. de geboortedatum. */
    aowDatum: string | null;
    /** Kredieten van de aanvrager. */
    kredieten: MaximaleHypotheekKredietInput[] | null;
}

/** Het invoermodel voor de maximale hypotheek berekening. */
export interface MaximaleHypotheekInput {
    /** De gegevens van de klanten. */
    aanvragers: MaximaleHypotheekAanvragerInput[] | null;
    /** Looptijd van de gewenste hypotheek in jaren. */
    looptijd: number | null;
    /** Het bedrag aan energiebesparende maatregelen. */
    energieBesparendeMaatregelen: number | null;
    /** Het gedeelte van de hypotheek dat in box3 terecht komt. */
    box3Deel: number | null;
    /** De hypotheekrente waarmee gerekend moet worden. */
    toetsrente: number;
    aflosvorm: AflosvormOptions;
    /** Marktwaarde waarmee rekening gehouden moet worden tijdens de berekening. */
    marktwaarde: number | null;
    tarievenNorm: TarievenNorm | null;
}

/** De invoer van het krediet voor de berekening maximale hypotheek. */
export interface MaximaleHypotheekKredietInput {
    soortKrediet: KredietsoortOptions;
    /** Bedrag oorspronkelijke hoofdsom.
In het geval van een doorlopend krediet dient hier de limiet ingevuld te worden. */
    oorspronkelijkeHoofdsom: number | null;
    /** Bedrag werkelijke bruto maandlast. */
    brutoMaandlast: number | null;
    /** Aantal maanden looptijd. */
    looptijdInMaanden: number | null;
}

/** Bevat de output van de maximale hypotheek berekening. */
export interface MaximaleHypotheekOutput {
    resultaat: MaximaleHypotheekResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de maximale hypotheek berekening. */
export interface MaximaleHypotheekResultaat {
    /** De berekende maximale hypotheek. */
    maximaleHypotheekChf: number | null;
    /** De maximale hypotheek als er rekening gehouden wordt met de NHG-normen. */
    maximaleHypotheekNhg: number | null;
    /** De gebruikte toetsrente. */
    toetsrente: number | null;
    /** De maximaal toegestane jaarlast. */
    toegestaneJaarlast: number | null;
    /** De bepaalde woonquote. */
    woonquote: number | null;
    /** De maximale hypotheek o.b.v. marktwaarde. */
    maximaleHypotheekMarktwaarde: number | null;
}

export interface NhgMogelijkOutput {
    maxKoopsomResult: MaxKoopsomOutput | null;
    maxKostenInEigendomResult: MaxKostenInEigendomOutput | null;
    tweedeWoningNietMogelijkResult: TweedeWoningNietMogelijkOutput | null;
    maxLeningResult: MaxLeningOutput | null;
}

/** De invoer voor de overbruggingskrediet-berekening. */
export interface OverbruggingskredietInput {
    /** Overwaarde huidige woning(en). */
    overwaardeHuidigeWoningenBedrag: number | null;
    /** Meenemen in overbruggingskrediet. */
    meenemenInOverbruggingskredietBedrag: number | null;
    /** Bedrag reservering lagere verkoopopbrengst. */
    reserveringLagereVerkoopopbrengstBedrag: number | null;
    /** Het rentepercentage van het overbruggingskrediet. */
    renteOverbruggingskredietPercentage: number | null;
    /** Afsluitkosten. */
    afsluitkostenBedrag: number | null;
    /** Ingangsdatum overbruggingskrediet */
    ingangsdatum: string;
    /** Einddatum overbruggingskrediet */
    einddatum: string;
    /** Fiscale gegevens Bedrag deel box 1. */
    box1Bedrag: number | null;
    /** Fiscale gegevens percentage deel box 1. */
    box1Percentage: number | null;
    /** Fiscale gegevens Bedrag deel box 3. */
    box3Bedrag: number | null;
    /** Fiscale gegevens percentage deel box 3. */
    box3Percentage: number | null;
    tarievenNorm: TarievenNorm | null;
}

/** De uitvoer van de overbruggingskrediet-berekening. */
export interface OverbruggingskredietOutput {
    resultaat: OverbruggingskredietResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de overbruggingskrediet berekening. */
export interface OverbruggingskredietResultaat {
    /** Bedrag totale overbruggingskrediet. */
    totaalOverbruggingskredietBedrag: number | null;
    /** Maandelijkse rentelast bruto. */
    rentelastMaandelijksBrutoBedrag: number | null;
    /** Maandelijkse rentelast netto. */
    rentelastMaandelijksNettoBedrag: number | null;
    /** Totale rentelast bruto. */
    rentelastTotaalBrutoBedrag: number | null;
    /** Totale rentelast netto. */
    rentelastTotaalNettoBedrag: number | null;
}

/** De invoer voor de berekening van renteverlies tijdens bouw. */
export interface RenteverliesTijdensBouwInput {
    /** Duur van de bouw in maanden. */
    duur: number;
    /** Het bouwdepotbedrag. */
    bouwdepotbedrag: number;
    /** Het hypotheekbedrag. */
    hypotheekbedrag: number;
    /** De hypotheekrente. */
    hypotheekrente: number;
    /** De rentevergoeding op het bouwdepot. */
    rentevergoeding: number;
    /** Specificatie van de uitbetalingen per maand. */
    uitbetalingen: RenteverliesTijdensBouwMaandInput[] | null;
}

/** Specificatie van de opname in een maand. */
export interface RenteverliesTijdensBouwMaandInput {
    /** Maandnummer van de specificatie. */
    maand: number;
    /** Percentage uitbetaling ten opzichte van het volledige bedrag. */
    percentageUitbetaling: number;
}

/** Een maandbedrag uit de berekening van het renteverlies tijdens bouw. */
export interface RenteverliesTijdensBouwMaandOutput {
    /** De maand binnen de looptijd waarvoor de verdere waardes gelden. */
    maand: number;
    /** In deze maand resterende bouwdepotbedrag */
    hoogteBouwdepot: number;
    /** In deze maand genoten uitbetaling. */
    uitbetaling: number;
    /** Het bedrag aan rentevergoeding dat deze maand genoten wordt op het bouwdepot. */
    rentevergoeding: number;
    /** Bedrag aan hypotheekrente dat betaald wordt in deze maand. */
    betaaldeHypotheekrente: number;
    /** Bedrag aan renteverlies in deze maand. */
    renteverlies: number;
}

/** Bevat de output van de renteverlies tijdens bouw berekening. */
export interface RenteverliesTijdensBouwOutput {
    resultaat: RenteverliesTijdensBouwResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de renteverlies tijdens bouw berekening. */
export interface RenteverliesTijdensBouwResultaat {
    /** Volledige bedrag aan renteverlies over de gehele bouwperiode. */
    totaalRenteverlies: number;
    /** De waardes per maand van de duur van de bouw. Loopt door tot en met de laatste maand van de duur van de bouw. */
    maandbedragen: RenteverliesTijdensBouwMaandOutput[] | null;
}

/** SoortWaardeberekeningOptions Geen = 0, VastBedrag = 1, Percentage = 2, Default = 3 */
export enum SoortWaardeberekeningOptions {
    Geen = "Geen",
    VastBedrag = "VastBedrag",
    Percentage = "Percentage",
    Default = "Default",
}

export interface TarievenNorm {
    jaar: number;
    maand: number;
}

export interface TweedeWoningNietMogelijkOutput {
    success: boolean | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

/** Specificatie van de kosten voor verbouwing of verbetering. */
export interface VerbouwingVerbetering {
    /** De kosten voor verbouwing of verbetering die niet waardevermeerderend zijn. */
    kostenNietWaardevermeerderend: number | null;
    /** De kosten voor energiebesparende maatregelen. */
    kostenEnergiebesparend: number | null;
    /** De kosten voor herstel van achterstallig onderhoud. */
    kostenAchterstalligOnderhoud: number | null;
    /** De kosten voor verbouwing of verbetering die waardevermeerderend zijn en niet onder achterstallig onderhoud en energiebesparend vallen */
    kostenWaardevermeerderend: number | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** De parameters voor de waardeberekening van een bepaald gegeven */
export interface WaardeberekeningParameters {
    soortWaardeberekening: SoortWaardeberekeningOptions;
    /** Het bedrag van de waarde, indien van toepassing */
    bedrag: number | null;
    /** Het percentage voor de berekening, indien van toepassing */
    percentage: number | null;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}